import React, { Fragment } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import ShareIcons from "../icons/ShareIcons";

const RestaurantCardButtons = ({ city, restaurantId, name }) => {
  let website = `https://www.table-sage.com/locate?restaurant=${restaurantId}`;

  let cityName;

  if (city === "5f69d9b4b28c5e1f8f369c42") {
    cityName = "Amsterdam";
  }

  const copyToClipboard = () => {
    if (typeof window !== `undefined`) {
      const el = document.createElement("textarea"); // Create a <textarea> element
      el.value = website; // Set its value to the string that you want copied
      el.setAttribute("readonly", ""); // Make it readonly to be tamper-proof
      el.style.position = "absolute";
      el.style.left = "-9999px"; // Move outside the screen to make it invisible
      document.body.appendChild(el); // Append the <textarea> element to the HTML document
      const selected =
        document.getSelection().rangeCount > 0 // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0) // Store selection if found
          : false; // Mark as false to know no selection existed before
      el.select(); // Select the <textarea> content
      document.execCommand("copy"); // Copy - only works as a result of a user action (e.g. click events)
      document.body.removeChild(el); // Remove the <textarea> element
      if (selected) {
        // If a selection existed before copying
        document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
        document.getSelection().addRange(selected); // Restore the original selection
      }
    }
  };

  return (
    <Fragment>
      <div className="restaurant-card__buttons">
        <div className="restaurant-card__buttons--small">
          <svg width="38px" height="38px" viewBox="0 0 38 38">
            <g
              id="Plus-content"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g
                id="New-Restaurant-Cards"
                transform="translate(-1286.000000, -1978.000000)"
              >
                <g
                  id="Group-4-Copy-5"
                  transform="translate(721.000000, 1956.000000)"
                >
                  <g
                    id="Icons/Restaurant-Card/-Share/Dark"
                    transform="translate(566.000000, 22.000000)"
                  >
                    <g id="Group">
                      <circle
                        id="Oval"
                        stroke="#231F20"
                        fill="#FFFFFF"
                        fillRule="nonzero"
                        cx="18.1839583"
                        cy="18.6079167"
                        r="18.0914583"
                      ></circle>
                      <g
                        id="Group-2"
                        transform="translate(10.097917, 10.699167)"
                        stroke="#000000"
                        strokeWidth="1.3"
                      >
                        <circle
                          id="Oval"
                          fill="#FFFFFF"
                          fillRule="nonzero"
                          cx="12.3102083"
                          cy="13.5127083"
                          r="2.3125"
                        ></circle>
                        <circle
                          id="Oval"
                          fill="#FFFFFF"
                          fillRule="nonzero"
                          cx="2.66708333"
                          cy="8.17854167"
                          r="2.66708333"
                        ></circle>
                        <path
                          d="M10.151875,12.90375 L4.7175,9.76645833"
                          id="Path"
                        ></path>
                        <path
                          d="M10.2366667,3.491875 L4.82541667,6.81416667"
                          id="Path"
                        ></path>
                        <circle
                          id="Oval"
                          fill="#FFFFFF"
                          fillRule="nonzero"
                          cx="12.3102083"
                          cy="2.3125"
                          r="2.3125"
                        ></circle>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div className="restaurant-card__share-collection">
          <div
            onClick={copyToClipboard}
            className="restaurant-card__share-item"
          >
            <div className="restaurant-card__buttons--copy">
              <ShareIcons icon="copy" />
            </div>
          </div>
          <div className="restaurant-card__share-item">
            <TwitterShareButton
              children={
                <Fragment>
                  <div>
                    <ShareIcons icon="twitter" />
                  </div>
                </Fragment>
              }
              title={`Check out ${cityName} restaurant ${name} on Table Sage! `}
              url={website}
            />
          </div>
          <div className="restaurant-card__share-item">
            <FacebookShareButton
              children={
                <Fragment>
                  <div>
                    <ShareIcons icon="facebook" />
                  </div>
                </Fragment>
              }
              quote={`Check out ${cityName} restaurant ${name} on Table Sage! `}
              url={website}
            />
          </div>
          <div className="restaurant-card__share-item">
            <WhatsappShareButton
              id="whatsapp-btn"
              children={
                <Fragment>
                  <div>
                    <ShareIcons icon="whatsapp" />{" "}
                  </div>
                </Fragment>
              }
              title={`Check out ${cityName} restaurant ${name} on Table Sage! `}
              separator="&#x000D;"
              url={website}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RestaurantCardButtons;
